(function () {
  /*
   * Modulo do component tarefa-list (tarefasList)
   */
  angular
    .module('tarefa', []);
})();
